/**
 * @generated SignedSource<<e224ac02ff478318d290c96ec5d52938>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ApprovalFilter = "AWAITING_ANY" | "AWAITING_MINE" | "HAS_ANY" | "HAS_MINE";
export type CompetitionApprovalPageQuery$variables = {
  approvalFilter?: ApprovalFilter | null | undefined;
  slug: string;
};
export type CompetitionApprovalPageQuery$data = {
  readonly competitionBySlug: {
    readonly id: string;
    readonly title: string;
    readonly " $fragmentSpreads": FragmentRefs<"CompetitionApprovalsFragment" | "CompetitionJuryFragment" | "CompetitionScoringCriteriaFragment">;
  } | null | undefined;
};
export type CompetitionApprovalPageQuery = {
  response: CompetitionApprovalPageQuery$data;
  variables: CompetitionApprovalPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "approvalFilter"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "slug"
},
v2 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v5 = {
  "kind": "Variable",
  "name": "approvalFilter",
  "variableName": "approvalFilter"
},
v6 = {
  "kind": "Literal",
  "name": "first",
  "value": 10
},
v7 = [
  (v6/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v12 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "jobTitle",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
},
v13 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isEntity"
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageThumbnail",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v17 = {
  "alias": "viewerCanApprove",
  "args": [
    {
      "kind": "Literal",
      "name": "action",
      "value": "CREATE_PROJECT_VERSION_APPROVAL"
    }
  ],
  "kind": "ScalarField",
  "name": "viewerCan",
  "storageKey": "viewerCan(action:\"CREATE_PROJECT_VERSION_APPROVAL\")"
},
v18 = [
  (v5/*: any*/),
  (v6/*: any*/)
],
v19 = [
  (v3/*: any*/),
  (v4/*: any*/),
  (v16/*: any*/)
],
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accept",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notes",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CompetitionApprovalPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "Competition",
        "kind": "LinkedField",
        "name": "competitionBySlug",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CompetitionJuryFragment"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CompetitionScoringCriteriaFragment"
          },
          {
            "args": [
              (v5/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "CompetitionApprovalsFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "CompetitionApprovalPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "Competition",
        "kind": "LinkedField",
        "name": "competitionBySlug",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": "viewerCanAddJuryMember",
            "args": [
              {
                "kind": "Literal",
                "name": "action",
                "value": "ADD_COMPETITION_JURY"
              }
            ],
            "kind": "ScalarField",
            "name": "viewerCan",
            "storageKey": "viewerCan(action:\"ADD_COMPETITION_JURY\")"
          },
          {
            "alias": "viewerCanRemoveJuryMember",
            "args": [
              {
                "kind": "Literal",
                "name": "action",
                "value": "REMOVE_COMPETITION_JURY"
              }
            ],
            "kind": "ScalarField",
            "name": "viewerCan",
            "storageKey": "viewerCan(action:\"REMOVE_COMPETITION_JURY\")"
          },
          {
            "alias": null,
            "args": (v7/*: any*/),
            "concreteType": "CompetitionJuryConnection",
            "kind": "LinkedField",
            "name": "jury",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CompetitionJuryEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "selectedOn",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v3/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v15/*: any*/)
            ],
            "storageKey": "jury(first:10)"
          },
          {
            "alias": null,
            "args": (v7/*: any*/),
            "filters": null,
            "handle": "connection",
            "key": "CompetitionJuryFragment_jury",
            "kind": "LinkedHandle",
            "name": "jury"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "slug",
            "storageKey": null
          },
          {
            "alias": "viewerCanEdit",
            "args": [
              {
                "kind": "Literal",
                "name": "action",
                "value": "UPDATE_COMPETITION"
              }
            ],
            "kind": "ScalarField",
            "name": "viewerCan",
            "storageKey": "viewerCan(action:\"UPDATE_COMPETITION\")"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CompetitionScoringCriterion",
            "kind": "LinkedField",
            "name": "scoringCriteria",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v16/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "weight",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v17/*: any*/),
          {
            "alias": "viewerCanReadPrivateApproval",
            "args": [
              {
                "kind": "Literal",
                "name": "action",
                "value": "READ_COMPETITION_PRIVATE_APPROVAL"
              }
            ],
            "kind": "ScalarField",
            "name": "viewerCan",
            "storageKey": "viewerCan(action:\"READ_COMPETITION_PRIVATE_APPROVAL\")"
          },
          {
            "alias": "anySubmission",
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 1
              }
            ],
            "concreteType": "SubmissionConnection",
            "kind": "LinkedField",
            "name": "submissions",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SubmissionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  (v8/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "submissions(first:1)"
          },
          {
            "alias": null,
            "args": (v18/*: any*/),
            "concreteType": "SubmissionConnection",
            "kind": "LinkedField",
            "name": "submissions",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SubmissionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Submission",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "entity",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v13/*: any*/),
                          (v11/*: any*/),
                          (v14/*: any*/),
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProjectVersion",
                        "kind": "LinkedField",
                        "name": "latest",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "version",
                            "storageKey": null
                          },
                          {
                            "alias": "viewerCanReadFiles",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "action",
                                "value": "READ_PROJECT_VERSION_FILE"
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "viewerCan",
                            "storageKey": "viewerCan(action:\"READ_PROJECT_VERSION_FILE\")"
                          },
                          {
                            "alias": "approvalsCheck",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "first",
                                "value": 2
                              }
                            ],
                            "concreteType": "ProjectVersionApprovalConnection",
                            "kind": "LinkedField",
                            "name": "approvals",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProjectVersionApproval",
                                "kind": "LinkedField",
                                "name": "nodes",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": "viewerCanRead",
                                    "args": [
                                      {
                                        "kind": "Literal",
                                        "name": "action",
                                        "value": "READ_PROJECT_VERSION_APPROVAL"
                                      }
                                    ],
                                    "kind": "ScalarField",
                                    "name": "viewerCan",
                                    "storageKey": "viewerCan(action:\"READ_PROJECT_VERSION_APPROVAL\")"
                                  },
                                  (v3/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "approvals(first:2)"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "status",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProjectVersionEvaluation",
                            "kind": "LinkedField",
                            "name": "evaluation",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "score",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "error",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "finalizedAt",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "max",
                                "storageKey": null
                              },
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "project",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Competition",
                                "kind": "LinkedField",
                                "name": "competition",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "showMetric",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "noCode",
                                    "storageKey": null
                                  },
                                  (v3/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CompetitionScoringCriterion",
                                    "kind": "LinkedField",
                                    "name": "scoringCriteria",
                                    "plural": true,
                                    "selections": (v19/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "entity",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/),
                              (v11/*: any*/),
                              (v10/*: any*/),
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProjectVersionApproval",
                            "kind": "LinkedField",
                            "name": "approval",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/),
                              (v3/*: any*/),
                              (v20/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProjectVersionApprovalScore",
                                "kind": "LinkedField",
                                "name": "scores",
                                "plural": true,
                                "selections": [
                                  (v3/*: any*/),
                                  (v21/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CompetitionScoringCriterion",
                                    "kind": "LinkedField",
                                    "name": "competitionScoringCriterion",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v22/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v17/*: any*/),
                          {
                            "alias": null,
                            "args": (v7/*: any*/),
                            "concreteType": "ProjectVersionApprovalConnection",
                            "kind": "LinkedField",
                            "name": "approvals",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProjectVersionApprovalEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  (v8/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ProjectVersionApproval",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v20/*: any*/),
                                      (v22/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ProjectVersionApprovalScore",
                                        "kind": "LinkedField",
                                        "name": "scores",
                                        "plural": true,
                                        "selections": [
                                          (v3/*: any*/),
                                          (v21/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "CompetitionScoringCriterion",
                                            "kind": "LinkedField",
                                            "name": "competitionScoringCriterion",
                                            "plural": false,
                                            "selections": (v19/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "entity",
                                        "plural": false,
                                        "selections": [
                                          (v9/*: any*/),
                                          (v10/*: any*/),
                                          (v11/*: any*/),
                                          (v12/*: any*/),
                                          (v13/*: any*/),
                                          (v14/*: any*/),
                                          (v3/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v3/*: any*/),
                                      (v9/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v15/*: any*/)
                            ],
                            "storageKey": "approvals(first:10)"
                          },
                          {
                            "alias": null,
                            "args": (v7/*: any*/),
                            "filters": null,
                            "handle": "connection",
                            "key": "SubmissionApprovalsFragment_approvals",
                            "kind": "LinkedHandle",
                            "name": "approvals"
                          }
                        ],
                        "storageKey": null
                      },
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v8/*: any*/)
                ],
                "storageKey": null
              },
              (v15/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v18/*: any*/),
            "filters": [
              "approvalFilter"
            ],
            "handle": "connection",
            "key": "CompetitionApprovalsFragment_submissions",
            "kind": "LinkedHandle",
            "name": "submissions"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5bfdbec48ab0882c852337faf4e582b0",
    "id": null,
    "metadata": {},
    "name": "CompetitionApprovalPageQuery",
    "operationKind": "query",
    "text": "query CompetitionApprovalPageQuery(\n  $slug: String!\n  $approvalFilter: ApprovalFilter\n) {\n  competitionBySlug(slug: $slug) {\n    id\n    title\n    ...CompetitionJuryFragment\n    ...CompetitionScoringCriteriaFragment\n    ...CompetitionApprovalsFragment_2hOCSi\n  }\n}\n\nfragment BaseProjectVersionApprovalButtonFragment on ProjectVersion {\n  id\n  version\n  entity {\n    __typename\n    displayName\n    username\n    id\n  }\n  approval {\n    __typename\n    id\n    accept\n    scores {\n      id\n      value\n      competitionScoringCriterion {\n        id\n      }\n    }\n    notes\n  }\n  project {\n    __typename\n    id\n    competition {\n      id\n      scoringCriteria {\n        id\n        title\n        description\n      }\n    }\n  }\n  viewerCanApprove: viewerCan(action: CREATE_PROJECT_VERSION_APPROVAL)\n  ...SubmissionStatusBadgeFragment\n}\n\nfragment CompetitionApprovalsFragment_2hOCSi on Competition {\n  viewerCanApprove: viewerCan(action: CREATE_PROJECT_VERSION_APPROVAL)\n  viewerCanReadPrivateApproval: viewerCan(action: READ_COMPETITION_PRIVATE_APPROVAL)\n  anySubmission: submissions(first: 1) {\n    edges {\n      cursor\n    }\n  }\n  ...FiltersForCompetitionApprovalsFragment\n  ...SubmissionsCompetitionApprovalsFragment_2hOCSi\n}\n\nfragment CompetitionJuryFragment on Competition {\n  viewerCanAddJuryMember: viewerCan(action: ADD_COMPETITION_JURY)\n  viewerCanRemoveJuryMember: viewerCan(action: REMOVE_COMPETITION_JURY)\n  jury(first: 10) {\n    edges {\n      cursor\n      selectedOn\n      node {\n        __typename\n        id\n        username\n        displayName\n        ... on User {\n          jobTitle\n        }\n        ...EntityProfilePicFragment_49kWkb\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment CompetitionScoringCriteriaFragment on Competition {\n  slug\n  viewerCanEdit: viewerCan(action: UPDATE_COMPETITION)\n  scoringCriteria {\n    id\n    title\n    description\n    weight\n  }\n}\n\nfragment EntityProfilePicFragment_49kWkb on Entity {\n  __isEntity: __typename\n  displayName\n  imageThumbnail\n}\n\nfragment FiltersForCompetitionApprovalsFragment on Competition {\n  viewerCanApprove: viewerCan(action: CREATE_PROJECT_VERSION_APPROVAL)\n}\n\nfragment SubmissionApprovalsFragment on ProjectVersion {\n  entity {\n    __typename\n    username\n    displayName\n    id\n  }\n  approvals(first: 10) @ifAllowed {\n    edges {\n      cursor\n      node {\n        accept\n        notes\n        scores {\n          id\n          value\n          competitionScoringCriterion {\n            id\n            title\n            description\n          }\n        }\n        entity {\n          __typename\n          username\n          displayName\n          ... on User {\n            jobTitle\n          }\n          ...EntityProfilePicFragment_49kWkb\n          id\n        }\n        id\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment SubmissionStatusBadgeFragment on ProjectVersion {\n  id\n  status\n  version\n  evaluation {\n    score\n    error\n    finalizedAt\n    max\n    id\n  }\n  project {\n    __typename\n    competition {\n      showMetric\n      noCode\n      id\n    }\n    id\n  }\n}\n\nfragment SubmissionsCompetitionApprovalsFragment_2hOCSi on Competition {\n  slug\n  viewerCanApprove: viewerCan(action: CREATE_PROJECT_VERSION_APPROVAL)\n  submissions(approvalFilter: $approvalFilter, first: 10) {\n    edges {\n      node {\n        id\n        entity {\n          __typename\n          username\n          ...EntityProfilePicFragment_49kWkb\n          id\n        }\n        latest {\n          id\n          version\n          viewerCanReadFiles: viewerCan(action: READ_PROJECT_VERSION_FILE)\n          approvalsCheck: approvals(first: 2) @ifAllowed {\n            nodes {\n              viewerCanRead: viewerCan(action: READ_PROJECT_VERSION_APPROVAL)\n              id\n            }\n          }\n          ...SubmissionStatusBadgeFragment\n          ...BaseProjectVersionApprovalButtonFragment\n          ...SubmissionApprovalsFragment\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n"
  }
};
})();

(node as any).hash = "99fbe3cefcb25df86ea941c37339fae3";

export default node;
